import React from 'react';
import { Button } from '@roger/ui-components';
import { useNavigate } from 'react-router-dom';
import { useBreadcrumbs } from '../components/breadcrumbs/BreadcrumbContext';
import X12_837I_Testing from '../components/X12_837I_Testing';

const TestingX12_837: React.FC = () => {
  const navigate = useNavigate();
  useBreadcrumbs([{ label: 'X12 837' }]);

  return (
    <div className='space-y-6'>
      <div className='flex items-center justify-between'>
        <div className='flex items-center space-x-4'>
          <Button
            variant='outline'
            onClick={() => navigate('/testing')}
            className='flex items-center space-x-2'
          >
            <span>←</span>
            <span>Back to Testing</span>
          </Button>
        </div>
      </div>

      <X12_837I_Testing />
    </div>
  );
};

export default TestingX12_837;
